export default __webpack_public_path__ + "static/media/cover.3833f548.png";